import { useContext } from 'react'
import { ShortVideosStateContext } from './short-videos-state'

export function useShortVideosState() {
  const context = useContext(ShortVideosStateContext)

  if (!context) {
    throw new Error('useShortVideosState must be used inside ShortVideosStateProvider.')
  }

  return context
}
